<div class="form-group row" *ngIf="!!liveSubtitles">
	<label id="ewLiveEventSubtitles" [ngClass]="styles.topLabel">{{ 'Event_LiveEventSubtitles' | translate}}</label>
	<div [ngClass]="styles.outerContainer">
		<div class="row">
			<div [ngClass]="styles.innerContainer">
				<div vbUiRadioBtnGroup aria-labelledby="ewLiveEventSubtitles">
					<button type="button" [ngClass]="styles.radioBtn" [(ngModel)]="liveSubtitles.isLiveSubtitlesEnabled" [vbUiRadioBtn]="true" [notThemed]="!isAdHoc" [activeClass]="isAdHoc ? '' : 'active'" (ngModelChange)="onSubtitleOptionChange()">
						{{ 'UI_Enabled' | translate }}
					</button>
					<button type="button" [ngClass]="styles.radioBtn" [(ngModel)]="liveSubtitles.isLiveSubtitlesEnabled" [vbUiRadioBtn]="false" [notThemed]="!isAdHoc" [activeClass]="isAdHoc ? '' : 'active'" (ngModelChange)="onSubtitleOptionChange()">
						{{ 'UI_Disabled' | translate }}
					</button>
				</div>
			</div>
			<div *ngIf="errors && errors[ErrorDetails.INVALID_PRESENTATION_PROFILE_SOURCE]" [ngClass]="styles.error" role="alert" vbUiErrorMessage>
				{{ 'Event_LiveEventSubtitles_PresentationProfileNotSupported' | translate }}
			</div>
			<div *ngIf="errors && errors[ErrorDetails.INVALID_SOURCE]" [ngClass]="styles.error" role="alert" vbUiErrorMessage>
				{{ 'Event_LiveEventSubtitles_SourceNotSupported' | translate }}
			</div>
			<div *ngIf="errors && errors[ErrorDetails.REV_IQ_DISABLE]" [ngClass]="styles.error" role="alert" vbUiErrorMessage>
				{{ 'Event_LiveEventSubtitles_TranscriptionNotEnabled' | translate }}
			</div>
			<div *ngIf="errors && errors[ErrorDetails.INSUFFICIENT_REV_IQ_CREDIT]" [ngClass]="styles.error" role="alert" vbUiErrorMessage>
				{{ 'Event_LiveEventSubtitles_InsufficientRevIQCredits' | translate }}
			</div>
			<div *ngIf="errors && errors[ErrorDetails.INSUFFICIENT_VIEWING_HOURS]" [ngClass]="styles.error" role="alert" vbUiErrorMessage>
				{{ 'Event_LiveEventSubtitles_InsufficientViewingHours' | translate }}
			</div>
		</div>
	</div>
</div>
<div *ngIf="liveSubtitles?.isLiveSubtitlesEnabled">
	<div class="form-group row">
		<label [ngClass]="styles.topLabel"></label>
		<div [ngClass]="styles.outerContainer">
			<div [ngClass]="styles.row">
				<div [ngClass]="styles.innerContainer">
					<label for="ewSubtitleLang" [ngClass]="styles.label">{{ 'Event_LiveEventSubtitles_SourceLanguage' | translate }}</label>
					<vb-ui-select>
						<select id="ewSubtitleLang" #selectElement name="ewSubtitleLang" [(ngModel)]="liveSubtitles.sourceLanguage" (change)="onSourceLanguageChange()" required>
							<option *ngFor="let language of sourceLanguages" [ngValue]="language.code">{{language.name}}</option>
						</select>
					</vb-ui-select>
				</div>
			</div>
		</div>
	</div>
	<div class="form-group row">
		<label [ngClass]="styles.topLabel"></label>
		<div [ngClass]="styles.outerContainer">
			<div [ngClass]="styles.row">
				<div [ngClass]="styles.innerContainer">
					<label for="ewSubtitleTranslationLang" [ngClass]="styles.label">{{ 'Event_LiveEventSubtitles_TranslateLanguages' | translate }}</label>
					<vb-languages-tags-input [placeholder]="'Features_SelectLanguages' | translate" name="tags" [whitelist]="filteredLanguages" [ngModel]="selectedTranslations" (ngModelChange)="onTagsChanged($event)">
					</vb-languages-tags-input>
				</div>
				<div *ngIf="errors && errors[ErrorDetails.MAX_TRANS_LANG]" [ngClass]="styles.error" role="alert" vbUiErrorMessage>
					{{ 'Event_LiveEventSubtitles_TranslateLanguagesCountError' | translate : { '0':  MAX_TRANS_LANG_COUNT } }}
				</div>
			</div>
		</div>
	</div>
</div>
